<template>
    <div class="layout-wrapper">
        <div class="layout-body">
            <main class="content-area">
                <div class="content-inner">
                    <h3>{{ chapter }} : {{ topic }}</h3>

                    <div class="video-card">
                        <div class="video-wrapper">
                            <video v-if="isMp4" controls :key="videoUrl">
                                <source :src="videoUrl" type="video/mp4">
                                Your browser does not support video
                            </video>

                            <iframe v-else-if="isYoutube" :src="youtubeEmbed" :key="youtubeEmbed" frameborder="0"
                                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                            <div v-else class="invalid-url">
                                <p>Invalid or missing video URL</p>
                            </div>
                        </div>
                    </div>

                    <div class="nav-buttons">
                        <div class="nav-center">
                            <span class="nav-btn" @click="goPrev" :class="{ disabled: currentIndex === 0 }">
                                <v-icon small>mdi-chevron-left</v-icon> PREV
                            </span>

                            <span class="nav-btn" @click="goNext"
                                :class="{ disabled: currentIndex === videoList.length - 1 }">
                                NEXT <v-icon small>mdi-chevron-right</v-icon>
                            </span>
                        </div>

                        <span class="nav-btn nav-index" @click="goIndex">
                            <v-icon small>mdi-format-list-bulleted</v-icon> INDEX
                        </span>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            videoUrl: "",
            chapter: "",
            topic: "",
            currentIndex: 0,
            videoList: []
        };
    },

    computed: {
        isMp4() {
            return this.videoUrl && this.videoUrl.includes(".mp4");
        },

        isYoutube() {
            return (
                this.videoUrl &&
                (this.videoUrl.includes("youtube") ||
                    this.videoUrl.includes("youtu.be"))
            );
        },

        youtubeEmbed() {
            if (!this.videoUrl) return "";
            let id = "";

            if (this.videoUrl.includes("v=")) {
                id = this.videoUrl.split("v=")[1].split("&")[0];
            } else {
                id = this.videoUrl.split("/").pop();
            }

            return "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0";
        }
    },

    mounted() {
        try {
            this.videoList = JSON.parse(localStorage.getItem("video_list") || "[]");
            this.currentIndex = parseInt(localStorage.getItem("video_index") || "0");

            this.loadVideo(this.currentIndex);
        } catch (e) {
            console.error("Invalid localStorage data");
        }
    },

    methods: {
        loadVideo(index) {
            var item = this.videoList[index];
            if (!item) return;

            this.videoUrl = item.video_url || "";
            this.chapter = item.chapter_name || "";
            this.topic = item.topic_name || "";
            this.currentIndex = index;

            localStorage.setItem("video_index", index);
            localStorage.setItem("videoUrl", this.videoUrl);
        },

        goPrev() {
            if (this.currentIndex > 0) {
                this.loadVideo(this.currentIndex - 1);
            }
        },

        goNext() {
            if (this.currentIndex < this.videoList.length - 1) {
                this.loadVideo(this.currentIndex + 1);
            }
        },

        goIndex() {
            this.$router.push({ name: "digital-learning" });
        }
    }
};
</script>

<style scoped>
.layout-wrapper {
    display: flex;
    flex-direction: column;
    height: 85vh;
    overflow: hidden;
    background: #f8f7ff;
}

.layout-body {
    display: flex;
    flex: 1;
    height: 100%;
}

.content-area {
    flex: 1;
    height: 100%;
}

.content-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
}

.content-inner h3 {
    text-align: center;
    font-weight: 500;
    margin-bottom: 8px;
    color: #333;
}


.video-card {
    width: 90%;
    max-width: 1400px;
    height: calc(100vh - 140px);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.video-wrapper {
    width: 100%;
    height: 100%;
    background: #000;
}

video,
iframe {
    width: 100%;
    height: 100%;
    border: none;
    object-fit: contain;
}

/* NAVIGATION */
.nav-buttons {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 95%;
    max-width: 1400px;
    margin-top: 10px;
}

.nav-center {
    display: flex;
    align-items: center;
    gap: 32px;
}

.nav-index {
    position: absolute;
    right: 0;
}

.nav-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 600;
    color: #1a237e;
    cursor: pointer;
    letter-spacing: 0.04em;
    transition: color 0.15s ease;
    user-select: none;
    padding: 0 10px;
}

.nav-btn:hover {
    color: #5c6bc0;
}

.disabled {
    opacity: 0.35;
    pointer-events: none;
}
</style>
